export const useDebounce = (func: Function, wait: number) => {
	let time_out_ID: ReturnType<typeof setTimeout>

	return function (...args: any) {
		const context = this
		clearTimeout(time_out_ID)
		time_out_ID = setTimeout(() => func.apply(context, args), wait)
	}
}
